let showError = undefined;

const SetShowError = function (fnShowError) {
    showError = fnShowError;
}

const ShowError = function (error) {
    showError(error);
}

export default ShowError;

export {
    SetShowError
}